module.exports = __webpack_public_path__ + "static/media/refresh.9e808981.svg";